import type { RouteRecordRaw } from "vue-router";

export const CompanyRoutes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'companyGeneral',
        component: () => import('./components/General.vue')
    },
    {
        path: 'api',
        name: 'companyApi',
        component: () => import('./components/Api.vue')
    },
    {
        path: 'portals',
        name: 'companyPortal',
        component: () => import('./components/portal/Index.vue')
    },
    {
        path: 'whatsapp',
        name: 'companyWhatsapp',
        component: () => import('./components/WhatsApp.vue')
    },
    {
        path: 'theme',
        name: 'companyTheme',
        component: () => import('./components/Theme.vue')
    }
]